import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
  
      <p class="mb-3">
        «Наше дело правое! Мы победим!»
      </p>
      
      <p class="mb-3">
        Революционные лозунги развевались по всей стране. 
      </p>
        
      <p class="mb-3">
        «Долой правящую верхушку! Долой эксплуатацию! Не позволим никому эксплуатировать нас, трудящийся народ! Кто не работает, тот не ест!»
      </p>

        
      <p class="text-center bold mb-3">* * *</p>
      
      
      <p class="mb-3">
        И доступ крови к мозгу был перекрыт. 
      </p>

      <p class="mb-3">
        Жертвуя собою, лейкоциты, липиды, соединения кальция перекрывали артерии, ведущие к головному мозгу, чтобы этот паразит, 
        который всегда питался кровью рабочих, этот высокопоставленный гад, всегда получавший наилучшее питание 
        (а для кислорода был даже построен отдельный путь, чтобы самый чистый кислород – только ему…). 
      </p>

      <p class="mb-3">
        Нет, шалишь, брат, у нас теперь все равны. 
        Уничтожить систему малого круга кровообращения! 
        Сломать старую машину, поддерживавшую привилегии правящего класса! 
      </p>

        
      <p class="text-center bold mb-3">* * *</p>
      
      
      <p class="mb-3">
        Смерть организма наступила, как и положено, через 5 минут после гибели мозга. 
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `За демократию!`
}

const itemDate = {
  rus: `17 декабря 1987`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

